import { useScopedSelector } from 'ia-react-core';
import { Product, redirectTo } from 'omni-package-react-core';
import { GroupInsurance } from 'we-package-react-group-insurance';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useListAnalytics from './hooks/useListAnalytics';
import { StyledLink, StyledSpan, StyledInfoMessage, StyledList } from './List.styles';
import DefaultProductWidget from './DefaultProductWidget';
import { MyProductsResourceInfo } from '../../MyProductsResource/MyProductsResource';

export interface SectionProps { }

const List: FC<SectionProps> = () => {
  const { t } = useTranslation('MyProductsTile');
  const navigate = useNavigate();
  const products: Product[] = useScopedSelector(MyProductsResourceInfo.dataDst);
  useListAnalytics(products);

  if (!products) { return null; }
  if (products.length === 0) {
    return (<StyledInfoMessage data-testid="NoProductMessage"><StyledSpan>{t('noProductsText')}</StyledSpan><StyledLink onClick={() => redirectTo('/contact-us', navigate)} data-testid="link">{t('customerService')}</StyledLink></StyledInfoMessage>);
  }

  return (
    <StyledList>
      {products.map((product) =>
        product.ownerCode === 'AC' && !product.uniqueLinkText ?
          <GroupInsurance
            key={product.id}
            product={product}
          /> :
          <DefaultProductWidget key={product.id} product={product} />)}
    </StyledList>
  );
};
export default List;
